import { InjectionToken, Provider } from '@angular/core'

export const errorTitleToken = new InjectionToken<string>('ErrorTitleToken')

export const errorTitleProvider: Provider = {
  provide: errorTitleToken,
  useValue: $localize`:Title|Generic error title:Oops something went wrong`,
}
